import { Color } from "../../shared/Expr"
import { ColorSelectorGrid } from "../ui/ColorSelectorGrid"

// TODO(alvaro): this should just be a flat array
export const colors = [
  // Row 1
  { color: "#FFCDD2" },
  { color: "#FFE0B2" },
  { color: "#FFF9C4" },
  { color: "#C8E6C9" },
  { color: "#B2EBF2" },
  { color: "#BBDEFB" },
  { color: "#C5CAE9" },
  { color: "#E1BEE7" },
  { color: "#F8BBD0" },
  { color: "#D7CCC8" },
  { color: "#FFFFFF" }, // White

  // Row 2
  { color: "#F48FB1" },
  { color: "#FFB74D" },
  { color: "#FFF176" },
  { color: "#A5D6A7" },
  { color: "#80DEEA" },
  { color: "#90CAF9" },
  { color: "#9FA8DA" },
  { color: "#CE93D8" },
  { color: "#F06292" },
  { color: "#BCAAA4" },
  { color: "#E0E0E0" }, // Gray

  // Row 3
  { color: "#E57373" },
  { color: "#F57C00" },
  { color: "#FDD835" },
  { color: "#66BB6A" },
  { color: "#4DD0E1" },
  { color: "#64B5F6" },
  { color: "#5C6BC0" },
  { color: "#BA68C8" },
  { color: "#E91E63" },
  { color: "#A1887F" },
  { color: "#9E9E9E" }, // Medium Gray

  // Row 4
  { color: "#D32F2F" },
  { color: "#E65100" },
  { color: "#FBC02D" },
  { color: "#388E3C" },
  { color: "#00ACC1" },
  { color: "#1E88E5" },
  { color: "#3949AB" },
  { color: "#9C27B0" },
  { color: "#C2185B" },
  { color: "#795548" },
  { color: "#000000" }, // Black
]
type Props = {
  color: Color | undefined
  onChange: (color: Color) => void
}

export function ColorPicker({ color, onChange }: Props) {
  return (
    <div style={{ padding: 4 }}>
      <ColorSelectorGrid
        selectedColor={color ?? ("transparent" as Color)}
        colors={colors.map((c) => c.color as Color)}
        colorsPerRow={11}
        onSelect={onChange}
      />
    </div>
  )
}
